import {
  type RelevantUsersForAssetQuery,
  useRelevantUsersForAssetQuery,
} from "src/graphql";

/**
 * Everyone named on one ad, by user id. The users permission hides anyone
 * outside the viewer's organizations, so the comment and activity joins come
 * back null for them, most often staff who commented while impersonating.
 */
export type RelevantUsers = ReadonlyMap<
  number,
  { name: string; isHightouchStaff: boolean }
>;

export const NO_RELEVANT_USERS: RelevantUsers = new Map();

function toRelevantUsers(data: RelevantUsersForAssetQuery): RelevantUsers {
  return new Map(
    data.getRelevantUsersForAsset.map(({ userId, name, isHightouchStaff }) => [
      userId,
      { name, isHightouchStaff },
    ]),
  );
}

/** Not on the comment poll: who is on an ad changes far less often than its comments. */
export function useRelevantAssetUsers(
  adBriefAssetId: string | null | undefined,
): RelevantUsers {
  const { data } = useRelevantUsersForAssetQuery(
    { assetId: adBriefAssetId ?? "" },
    {
      enabled: Boolean(adBriefAssetId),
      select: toRelevantUsers,
      staleTime: RELEVANT_USERS_STALE_MS,
    },
  );

  return data ?? NO_RELEVANT_USERS;
}

const RELEVANT_USERS_STALE_MS = 30 * 60 * 1000;
